module.exports = __webpack_public_path__ + "img/jiande.3fd63c91.png";